import { getInvoiceByPatientId, getInvoiceDetailsByPatientId } from 'core/services/api'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/esm/Button'
import { useHistory, useParams } from 'react-router'
import "./InvoicesForPatient.scss"
import Dropdown from 'components/DropDown'

function InvoicesForPatient() {
  const sortByValues: { [key: string]: string } = { "Date": "appointmentDate", "Status": "status", "Pending": "pendingAmount" }
  const { patientId }: any = useParams()
  const [data, setData] = useState<any>();
  const [patientDetail, setPatientDetail] = useState<any>();
  const [sortType, setsortType] = useState<boolean>(false)
  const [sortBy, setSortBy] = useState<string>("Date")

  useEffect(() => {
    getInvoiceByPatientId(patientId)
      .then((res) => {
        // const newsorted = res.sort((a: any, b: any) =>
        //   a.patientName > b.patientName ? 1 : -1
        // )
        // setData(newsorted);
        setData(res);
      })
      .catch((err) => {
        console.log("err", err)
      })
    getInvoiceDetailsByPatientId(patientId)
      .then((res) => {
        // const newsorted = res.sort((a: any, b: any) =>
        //   a.patientName > b.patientName ? 1 : -1
        // )
        // setData(newsorted);

        setPatientDetail(res)
      })
      .catch((err) => {
        console.log("err", err)
      })



  }, [])

  const history = useHistory()
  function redirectTos(path: any) {

    history.push(`/invoices/patient/${path}`)

  }

  function redirectToRefund(path: any) {

    history.push(`/invoices/refund/${patientId}`)
  }

  function redirectToPatientLedger() {

    history.push(`/invoices/patientLedger/${patientId}`)
  }

  function redirectToPatientReceipt() {

    history.push(`/invoices/patientReceipt/${patientId}`)
  }

  function sortData(sortBy: string, sortType: boolean) {
    var sorted
    if (sortType) {
      sorted = [...data].sort((a: any, b: any) =>
        a[sortBy] > b[sortBy] ? 1 : -1
      )
    } else {
      sorted = [...data].sort((a: any, b: any) =>
        a[sortBy] < b[sortBy] ? 1 : -1
      )
    }
    setData(sorted)
  }
  if (!data) {
    return null
  }

  console.log("patientDetail", patientDetail)

  return (
    <div className='invoice-patient-wrapper'>
      <section className='top-container'>
        <div className='Left-element' >
          <div
            className="approval-back-image"
            onClick={() => {
              history.goBack()
            }}
          >
            <img
              src={"../../../../assets/images/back-icon.svg"}
              alt="back button"
              className="image-top-wrapper"
              style={{ height: "39px" }}
            />
          </div>
          <div className='Heading'>Billing</div>
          <div className="wrapper">
            <div className="security-advance-container">
              <div className="subheading-payment">Available Security Deposit:</div>
              <div className="subheading-value">
                {patientDetail?.totalSecurityDeposit?.toFixed(2)}
              </div>
              <div className="subheading-payment">Available Advance Payment:</div>
              <div className="subheading-value">
                {patientDetail?.totalAdvancePayment?.toFixed(2)}
              </div>

            </div>

          </div>

        </div>
        <div className="Right-Element">
          <div className="d-flex">
            <Dropdown
              className="px-3 h-auto"
              selected={sortBy}
              updateDropdown={(option: string) => {
                setSortBy(option)
                sortData(sortByValues[option], sortType)
              }}
              placeholder="Sort by"
              options={Object.keys(sortByValues)}
            />
            <img
              title="Sort"
              src={sortType ? '../../../../assets/images/sortDownArrow.svg' : '../../../../assets/images/sortUpArrow.svg'}
              alt="sort"
              onClick={() => {
                setsortType(!sortType)
                sortData(sortByValues[sortBy], !sortType)
              }}
            />
          </div>
          <img
            title="Receipt Print"
            src="../../../../assets/images/receiptPrint.svg"
            alt="receipt"
            onClick={() => {
              // @ts-ignore
              redirectToPatientReceipt()
            }} />
          <img
            title="Patient Ledger"
            src="../../../../assets/images/patientLedger.svg"
            alt="patientLeger"
            onClick={() => {
              // @ts-ignore
              redirectToPatientLedger()
            }} />
          <img
            title="Refund"
            src="../../../../assets/images/refund-icon.svg"
            alt="refund"
            onClick={() => {
              // @ts-ignore
              redirectToRefund(data)
            }} />
        </div>
      </section>
      <section className='top-container-bottom'>
        <div className='Left-element'></div>
        <div className="Right-Element">
          <div className="bill-pending">
            <Button className="common-button" style={{

            }}>
              Pending Bills Due-{patientDetail?.totalPendingAmount?.toFixed(2)}
            </Button>
          </div>
        </div>
      </section>

      {
        data?.map((value: any) => {
          const today = moment();
          const isToday = moment(value?.appointmentDate).isSame(today, 'day');

          return (
            <section className='accordian-section' >
              <details key={value?.mocId} >
                <summary className="accordian-details" style={{
                  border: isToday ? '3px solid rgb(107 151 255)' : 'none',
                  boxShadow: isToday ? '2px 2px 5px #888888' : 'none'
                }}>
                  <div className={`patient-primary`}  >
                    <div>
                      {" "}
                      <img
                        style={{ marginTop: "-4px", marginLeft: "24px", height: '28px' }}
                        src="../../assets/images/Group 7646.svg"
                        alt=""
                      ></img>
                    </div>
                    <div className="patient-name">{value?.isVip ? <><div>***Masked***</div></> : <>{value?.patientName}</>}</div>

                    <div style={{ width: '275px' }} className="patient-mocId">&nbsp;{value?.mocInvoiceId}</div>
                    <div className="patient-mocId" style={{ width: '25px' }}>{value?.appointmentType}</div>
                    <div className="patient-mocId">&nbsp;
                      {moment(value?.appointmentDate
                      ).format("DD-MM-YYYY")}
                    </div>
                    <div className="patient-mocId" style={{ width: "100px" }}>
                      <div>Total</div>
                      <div>{value?.finalAmount?.toFixed(2)}</div>
                    </div>
                    <div className="patient-mocId" style={{ width: "100px" }}>
                      <div>Paid</div>
                      <div>{value?.totalAmountPaid?.toFixed(2)}</div>
                    </div>
                    <div className="patient-mocId" style={{ width: "100px" }}>
                      <div>Pending</div>
                      <div>{value?.pendingAmount?.toFixed(2)}</div>
                    </div>
                    {value.status === "PENDING" ? (
                      <div className="patient-mocId" style={{ color: "red", width: '75px' }}>
                        {value?.status}
                      </div>
                    ) : (
                      <div className="patient-mocId" style={{ color: "green", width: '75px' }}>{value?.status}</div>
                    )}

                  </div>
                </summary>
                <div
                  className="accordian-summary"
                  onClick={() => {
                    // @ts-ignore
                    redirectTos(value?.id)
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div className="details-heading">
                    <div>Treatment & Procedure</div>
                    <div>Completed By</div>
                    <div>Cost</div>
                    <div>Discount %</div>
                    <div>Quantity</div>
                    <div>Tax %</div>
                    <div>Tax Amount</div>
                    <div>Total Cost</div>

                  </div>
                  <div className="details-data">
                    <div className="details-part2-parent">
                      {value?.invoiceItems.filter((item: any) => !item.archive).map((item: any, index: any) => {

                        return (
                          <div className="details-subdata-part2">
                            <div></div>
                            <div className="details-subdata2-treatment">
                              {index + 1} &nbsp; &nbsp;
                              {item?.treatmentAndDetails}
                            </div>
                            <div className="details-subdata2-completed">
                              {item?.completedBy}
                            </div>
                            <div className="details-subdata2-charges">{item?.cost}</div>
                            <div className="details-subdata2-discount">
                              {item?.discount}
                            </div>
                            <div className="details-subdata2-quantity">
                              {item?.quantity}
                            </div>
                            <div className="details-subdata2-taxes">
                              {item?.taxes.map((val: any, index: any) => {
                                return (
                                  <div>{val?.percentage}%</div>
                                )
                              })}
                            </div>
                            <div className="details-subdata2-taxes">
                              {item?.taxes.map((val: any, index: any) => {
                                return (
                                  <div>{val?.amount?.toFixed(2)}</div>
                                )
                              })}
                            </div>
                            <div className="details-subdata2-cost">
                              {item?.charges?.toFixed(2)}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  <div className="details-payment-part">
                    <div className="payment-data">{value?.totalAmount?.toFixed(2)}</div>
                    <div className="payment-data">Total</div>
                  </div>
                </div>
              </details>
            </section>
          )
        })
      }
    </div>
  )
}

export default InvoicesForPatient
